module.exports = __webpack_public_path__ + "static/media/fast-sportRight.9f3b2f14.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/slider-banners/fast-sport/fast-sportRight.svg
// module id = 2458
// module chunks = 7